// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainInputs[data-v-6337ed1c]{display:grid;grid-gap:16px;gap:16px;grid-template-columns:1fr;margin-bottom:16px}.cguWrapper[data-v-6337ed1c]{display:flex;justify-content:flex-start;align-content:flex-start;margin-bottom:32px}.cguText[data-v-6337ed1c]{margin-top:1px;margin-left:8px}.underlined[data-v-6337ed1c]{text-decoration:underline}.midWrapper[data-v-6337ed1c]{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
